// import React, { useState, useEffect } from "react";
// import FormField from "../../../components/ui/FormField";
// import { Button } from "../../../components/Button";

// const MbpTwoForm = () => {

//     const [footerInfo, setFooterInfo] = useState(() => {
//         const saved = localStorage.getItem("mbp2_footer_info");
//         return saved ? JSON.parse(saved) : { place: "", date: "", signature: "" };
//     });

//     const handleFooterChange = (field, value) => {
//         const updated = { ...footerInfo, [field]: value };
//         setFooterInfo(updated);
//         localStorage.setItem("mbp2_footer_info", JSON.stringify(updated));
//     };

//     const [entries, setEntries] = useState(() => {
//         const saved = localStorage.getItem("mbp2_register_data");
//         return saved ? JSON.parse(saved) : [{ id: Date.now() }];
//     });

//     useEffect(() => {
//         localStorage.setItem("mbp2_register_data", JSON.stringify(entries));
//     }, [entries]);

//     const updateField = (id, field, value) => {
//         setEntries(prev =>
//             prev.map(entry =>
//                 entry.id === id ? { ...entry, [field]: value } : entry
//             )
//         );
//     };

//     const addEntry = () => setEntries([...entries, { id: Date.now() }]);

//     const deleteEntry = (id) => {
//         if (entries.length > 1) {
//             setEntries(entries.filter((e) => e.id !== id));
//         }
//     };
// const saveData = () => {
//     const payload = {
//         registerName: "MBP-2",
//         footer: footerInfo,
//         entries: entries
//     };

//     console.log("MBP-2 PAYLOAD:",payload);
//     console.log(JSON.stringify(payload, null, 2));
// };

//     return (
//         <div >
//             <div className="bg-white px-6 mb-4 border-b-4 shadow-sm rounded-t-lg text-center">
//                 <h1 className="text-2xl text-gray-900 uppercase tracking-tight">Form MBP - 2</h1>
//                 <h2 className="text-lg font-semibold">Register of loans, guarantee, security and acquisition made by the company</h2>
//                 <p className="text-[10px] italic text-slate-500 mt-2">
//                     [Pursuant to section 186(9) & rule 12(1)]
//                 </p>
//             </div>

//             <div className="space-y-12">
//                 {entries.map((entry, index) => (
//                     <div key={entry.id} className="bg-white border border-slate-200 rounded-lg shadow">

//                         <div className="bg-primary text-white px-6 py-2 flex justify-between items-center">
//                             <span className="font-semibold text-xs uppercase">
//                                 Entry No: {index + 1}
//                             </span>
//                             {entries.length > 1 && (
//                                 <button
//                                     onClick={() => deleteEntry(entry.id)}
//                                     className="text-[10px] bg-red-600 px-3 py-1 rounded hover:bg-red-700 uppercase"
//                                 >
//                                     Remove
//                                 </button>
//                             )}
//                         </div>

//                         <div className="p-2 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">

//                             <FormField label=" Nature of transaction" value={entry.nature} onChange={(v) => updateField(entry.id, "nature", v)} />
//                             <FormField type="date" label=" Date of transaction" value={entry.date} onChange={(v) => updateField(entry.id, "date", v)} />
//                             <FormField type="description" label=" Name & Address of the entity" value={entry.entity} onChange={(v) => updateField(entry.id, "entity", v)} />

//                             <FormField label="Amount" value={entry.amount} onChange={(v) => updateField(entry.id, "amount", v)} />
//                             <FormField label=" Time period" value={entry.timePeriod} onChange={(v) => updateField(entry.id, "timePeriod", v)} />
//                             <FormField type="description" label=" Purpose" value={entry.purpose} onChange={(v) => updateField(entry.id, "purpose", v)} />

//                             <FormField label="% Exposure" value={entry.exposurePercent} onChange={(v) => updateField(entry.id, "exposurePercent", v)} />
//                             <FormField type="date" label=" Board resolution date" value={entry.boardDate} onChange={(v) => updateField(entry.id, "boardDate", v)} />
//                             <FormField type="date" label=" Special resolution date" value={entry.specialResolutionDate} onChange={(v) => updateField(entry.id, "specialResolutionDate", v)} />

//                             <FormField label=" Rate of Interest" value={entry.interestRate} onChange={(v) => updateField(entry.id, "interestRate", v)} />
//                             <FormField type="date" label="(11) Date of maturity" value={entry.maturityDate} onChange={(v) => updateField(entry.id, "maturityDate", v)} />

//                             <FormField label=" Number & Kind of securities" value={entry.securitiesType} onChange={(v) => updateField(entry.id, "securitiesType", v)} />
//                             <FormField label=" Nominal & Paid-up value" value={entry.nominalValue} onChange={(v) => updateField(entry.id, "nominalValue", v)} />
//                             <FormField type="description" label="Cost of acquisition" value={entry.costAcquisition} onChange={(v) => updateField(entry.id, "costAcquisition", v)} />

//                             <FormField type="date" label=" Date of selling" value={entry.sellingDate} onChange={(v) => updateField(entry.id, "sellingDate", v)} />
//                             <FormField label="Selling price" value={entry.sellingPrice} onChange={(v) => updateField(entry.id, "sellingPrice", v)} />
//                             <FormField type="description" label=" Signatures & Remarks" value={entry.remarks} onChange={(v) => updateField(entry.id, "remarks", v)} />

//                         </div>
//                     </div>
//                 ))}
//             </div>

//             <Button
//             label='Add New Entry'
//                 onClick={addEntry}
//                 className="mt-2 text-xs"
//             />
             
//             <div className="mt-2 bg-white p-2 rounded-lg shadow grid grid-cols-1 md:grid-cols-3 gap-6">
//                 <FormField label="Place" value={footerInfo.place} onChange={(v) => handleFooterChange("place", v)} />
//                 <FormField type="date" label="Date" value={footerInfo.date} onChange={(v) => handleFooterChange("date", v)} />
//                 <FormField label="Signature (MD/Director/Secretary)" value={footerInfo.signature} onChange={(v) => handleFooterChange("signature", v)} />
//             </div>
  
//   <div  className=" flex justify-end items-center">
//     <Button
//     label="SAVE"
//     onClick={saveData}
//     className="mt-2  mb-3 bg-green-600 text-white"
// />

//   </div>
//         </div>
//     );
// };

// export default MbpTwoForm;

import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import FormField from "../../../components/ui/FormField";
import { Button } from "../../../components/Button";
import { Mbp2RegisterApi } from "../../../api/Mbp2RegisterApi";
import { ArrowLeft, Trash2 } from "lucide-react";

const mapEntryToDTO = (entry) => ({
  natureOfTransaction: entry.nature || null,
  dateOfTransaction: entry.date || null,
  nameAndAddressOfEntity: entry.entity || null,
  amount: entry.amount ? parseFloat(entry.amount) : null,
  timePeriod: entry.timePeriod || null,
  purpose: entry.purpose || null,
  percentageOfExposure: entry.exposurePercent || null,
  boardResolutionDate: entry.boardDate || null,
  specialResolutionDate: entry.specialResolutionDate || null,
  forLoans: {
    rateOfInterest: entry.interestRate ? parseFloat(entry.interestRate) : null,
    dateOfMaturity: entry.maturityDate || null,
  },
  numberAndKindOfSecurities: entry.securitiesType || null,
  nominalValueAndPaidUpValue: entry.nominalValue || null,
  costOfAcquisition: entry.costAcquisition || null,
  dateOfSelling: entry.sellingDate || null,
  sellingPriceDetails: entry.sellingPrice || null,
  signaturesAndRemarks: entry.remarks || null,
});

const createDefaultEntry = () => ({ id: Date.now() + Math.random() });

const MbpTwoForm = () => {
  const token = useSelector((state) => state.auth.access_token);
  const companies = useSelector((state) => state.account.accountDetails);

  const [accountId, setAccountId] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const [footerInfo, setFooterInfo] = useState(() => {
    const saved = localStorage.getItem("mbp2_footer_info");
    return saved ? JSON.parse(saved) : { place: "", date: "", signature: "" };
  });

  const [entries, setEntries] = useState(() => {
    const saved = localStorage.getItem("mbp2_register_data");
    return saved ? JSON.parse(saved) : [createDefaultEntry()];
  });

  useEffect(() => {
    localStorage.setItem("mbp2_register_data", JSON.stringify(entries));
  }, [entries]);

  useEffect(() => {
    localStorage.setItem("mbp2_footer_info", JSON.stringify(footerInfo));
  }, [footerInfo]);

  // ── Handlers ──────────────────────────────────────────────────────────────

  const handleCompanyChange = (e) => {
    const selectedValue = e.target.value;
    if (selectedValue === "") {
      setAccountId("");
      return;
    }
    const selectedCompany = companies.find(
      (company) => String(company.id) === String(selectedValue)
    );
    if (selectedCompany) {
      setAccountId(selectedCompany.id);
    } else {
      console.error("Company not found for value:", selectedValue);
    }
  };

  const handleFooterChange = (field, value) => {
    setFooterInfo((prev) => ({ ...prev, [field]: value }));
  };

  const updateField = (id, field, value) => {
    setEntries((prev) =>
      prev.map((entry) =>
        entry.id === id ? { ...entry, [field]: value } : entry
      )
    );
  };

  const addEntry = () => {
    setEntries((prev) => [...prev, createDefaultEntry()]);
  };

  const deleteEntry = (id) => {
    if (entries.length > 1) {
      setEntries((prev) => prev.filter((e) => e.id !== id));
    }
  };

  // ── Save / Submit ──────────────────────────────────────────────────────────

  const handleSave = async () => {
    if (!accountId) {
      setSubmitStatus({
        type: "error",
        message: "Please select a company before saving.",
      });
      return;
    }

    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const payload = {
        place: footerInfo.place || null,
        date: footerInfo.date || null,
        signature: footerInfo.signature || null,
        mbp2RegisterEntryList: entries.map(mapEntryToDTO),
      };

      await Mbp2RegisterApi.submitMbp2Form(payload, accountId, token);

      setSubmitStatus({
        type: "success",
        message: "MBP-2 Register data saved successfully!",
      });

      // Clear localStorage after successful save
      localStorage.removeItem("mbp2_register_data");
      localStorage.removeItem("mbp2_footer_info");

      // Reset form state
      setEntries([createDefaultEntry()]);
      setFooterInfo({ place: "", date: "", signature: "" });
      setAccountId("");
    } catch (error) {
      setSubmitStatus({
        type: "error",
        message:
          error.message ||
          "Failed to save MBP-2 register data. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  // ── Render ─────────────────────────────────────────────────────────────────

  return (
    <div>
      {/* Form Header */}
      <div className="bg-white px-6 py-3 mb-2 border-b-4 shadow-sm rounded-xl relative text-center">
        <button
          onClick={() => window.history.back()}
          className="absolute top-3 left-4 flex items-center gap-2 text-gray-600 hover:text-gray-900"
        >
          <ArrowLeft size={18} />
          <span className="text-sm font-medium">Back</span>
        </button>
        <h1 className="text-2xl text-gray-900 uppercase tracking-tight">
          Form MBP - 2
        </h1>
        <h2 className="text-lg font-semibold">
          Register of loans, guarantee, security and acquisition made by the
          company
        </h2>
        <p className="text-[10px] italic text-slate-500 mt-2">
          [Pursuant to section 186(9) & rule 12(1)]
        </p>
      </div>

      {/* Company Selection */}
      <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-3 mb-2">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Name of the company *
        </label>
        <select
          value={accountId}
          onChange={handleCompanyChange}
          className="w-50 px-2 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="">Select a company</option>
          {companies.map((company) => (
            <option key={company.id} value={company.id}>
              {company.accountName || `Company ${company.id}`}
            </option>
          ))}
        </select>
      </div>

      {/* Status Message */}
      {submitStatus && (
        <div
          className={`mb-3 px-4 py-1 rounded-lg text-sm font-medium border ${
            submitStatus.type === "success"
              ? "bg-green-50 text-green-800 border-green-200"
              : "bg-red-50 text-red-800 border-red-200"
          }`}
        >
          {submitStatus.message}
        </div>
      )}

      {/* Entries */}
      <div className="space-y-2">
        {entries.map((entry, index) => (
          <div
            key={entry.id}
            className="bg-white border border-slate-200 rounded-lg shadow overflow-hidden"
          >
            <div className="bg-primary text-white px-3 py-2 flex justify-between items-center">
              <span className="font-semibold text-sm text-white uppercase">
                Entry No: {index + 1}
              </span>
              {entries.length > 1 && (
                <button
                  onClick={() => deleteEntry(entry.id)}
                  className="text-red-600 bg-white p-1 rounded-md"
                >
                  <Trash2 size={18}/>
                </button>
              )}
            </div>

            <div className="p-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
              <FormField
                label="Nature of transaction"
                value={entry.nature}
                onChange={(v) => updateField(entry.id, "nature", v)}
              />
              <FormField
                type="date"
                label="Date of transaction"
                value={entry.date}
                onChange={(v) => updateField(entry.id, "date", v)}
              />
              <FormField
                type="description"
                label="Name & Address of the entity"
                value={entry.entity}
                onChange={(v) => updateField(entry.id, "entity", v)}
              />
              <FormField
              type="number"
                label="Amount"
                value={entry.amount}
                onChange={(v) => updateField(entry.id, "amount", v)}
              />
              <FormField
                label="Time period"
                value={entry.timePeriod}
                onChange={(v) => updateField(entry.id, "timePeriod", v)}
              />
              <FormField
                type="description"
                label="Purpose"
                value={entry.purpose}
                onChange={(v) => updateField(entry.id, "purpose", v)}
              />
              <FormField
                label="% Exposure"
                value={entry.exposurePercent}
                onChange={(v) => updateField(entry.id, "exposurePercent", v)}
              />
              <FormField
                type="date"
                label="Board resolution date"
                value={entry.boardDate}
                onChange={(v) => updateField(entry.id, "boardDate", v)}
              />
              <FormField
                type="date"
                label="Special resolution date"
                value={entry.specialResolutionDate}
                onChange={(v) =>
                  updateField(entry.id, "specialResolutionDate", v)
                }
              />
              <FormField
              type="number"
                label="Rate of Interest"
                value={entry.interestRate}
                onChange={(v) => updateField(entry.id, "interestRate", v)}
              />
              <FormField
                type="date"
                label="Date of maturity"
                value={entry.maturityDate}
                onChange={(v) => updateField(entry.id, "maturityDate", v)}
              />
              <FormField
                label="Number & Kind of securities"
                value={entry.securitiesType}
                onChange={(v) => updateField(entry.id, "securitiesType", v)}
              />
              <FormField
                label="Nominal & Paid-up value"
                value={entry.nominalValue}
                onChange={(v) => updateField(entry.id, "nominalValue", v)}
              />
              <FormField
                type="description"
                label="Cost of acquisition"
                value={entry.costAcquisition}
                onChange={(v) => updateField(entry.id, "costAcquisition", v)}
              />
              <FormField
                type="date"
                label="Date of selling"
                value={entry.sellingDate}
                onChange={(v) => updateField(entry.id, "sellingDate", v)}
              />
              <FormField
                label="Selling price"
                value={entry.sellingPrice}
                onChange={(v) => updateField(entry.id, "sellingPrice", v)}
              />
              <FormField
                type="description"
                label="Signatures & Remarks"
                value={entry.remarks}
                onChange={(v) => updateField(entry.id, "remarks", v)}
              />
            </div>
          </div>
        ))}
      </div>
<div className="flex flex-row justify-end mt-2">

      <Button label="Add New Entry" onClick={addEntry} className="text-sm" />
</div>

      {/* Footer — Place / Date / Signature */}
      <div className="mt-2 bg-white p-3 rounded-lg shadow grid grid-cols-1 md:grid-cols-3 gap-2">
        <FormField
          label="Place"
          value={footerInfo.place}
          onChange={(v) => handleFooterChange("place", v)}
        />
        <FormField
          type="date"
          label="Date"
          value={footerInfo.date}
          onChange={(v) => handleFooterChange("date", v)}
        />
        <FormField
          label="Signature (MD/Director/Secretary)"
          value={footerInfo.signature}
          onChange={(v) => handleFooterChange("signature", v)}
        />
      </div>

      {/* Save Button */}
      <div className="flex justify-end items-center">
        <Button
          label={isSubmitting ? "Saving..." : "Save MBP-2 Register"}
          onClick={handleSave}
          disabled={isSubmitting}
          className="mt-2 mb-0 bg-green-600 hover:bg-green-700 text-white"
        />
      </div>
    </div>
  );
};

export default MbpTwoForm;